package dev.lingvo.site.components.marketing

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.toSitePalette

/** Preserve the comparison's reading order without a horizontal scroll on small screens. */
val AgentValueTableStyle = CssStyle {
    base { Modifier.styleModifier { property("display", "block") } }
    Breakpoint.MD { Modifier.styleModifier { property("display", "table") } }
}

val AgentValueHeadStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("position", "absolute")
            property("width", "1px")
            property("height", "1px")
            property("overflow", "hidden")
            property("clip-path", "inset(50%)")
        }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("position", "static")
            property("width", "auto")
            property("height", "auto")
            property("overflow", "visible")
            property("clip-path", "none")
        }
    }
}

val AgentValueBodyStyle = CssStyle {
    base { Modifier.styleModifier { property("display", "block") } }
    Breakpoint.MD { Modifier.styleModifier { property("display", "table-row-group") } }
}

val AgentValueRowStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("display", "block")
            property("padding-block", Space.MD.toString())
            property("border-top", "1px solid ${colorMode.toSitePalette().border}")
        }
    }
    Breakpoint.MD { Modifier.styleModifier { property("display", "table-row"); property("padding-block", "0"); property("border-top", "none") } }
}

val AgentValueCellStyle = CssStyle {
    base { Modifier.styleModifier { property("display", "block"); property("border-bottom", "none") } }
    Breakpoint.MD { Modifier.styleModifier { property("display", "table-cell") } }
}

val AgentValueCellLabelStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("display", "block")
            property("font-size", TypeScale.Small.toString())
            property("font-weight", "600")
            property("color", colorMode.toSitePalette().textPrimary.toString())
            property("margin-bottom", Space.XS.toString())
        }
    }
    Breakpoint.MD { Modifier.styleModifier { property("display", "none") } }
}
